/*
These functions make sure WordPress
and Foundation play nice together.
*/
// Trigger hamburger animation
// When DOM ready ...
jQuery(document).ready(function($) {
    // State
    let topMenuActive = false;

    // Cache dom object
    const $body = $("body");
    const $dropdownMenu = $("#dropdown-menu");

    // Custom toggle    
    $(".menu-hamburger-wrap").click(function(e) {
        console.log(e.target);
        if (topMenuActive) {
            $body.removeClass("top-menu-active");
            topMenuActive = false;
        }
        else {
            $body.addClass("top-menu-active");
            topMenuActive = true;
        }
    });

    // Check state on resize to prevent foundation hickup
    $(window).resize(function() {
        if (topMenuActive && ($dropdownMenu.attr("style") == "display: none;")) {
            $dropdownMenu.attr("style", "display: block;");
        }
    });

    $('#content-overlay').click(function(e) {
        $(".menu-hamburger-wrap.outer").trigger('click');
    });

    $('.to-top-button').click(function(e) {
		$('html, body').animate({scrollTop: 0}, 400, 'swing');
	});
});

// When all scripts loaded
jQuery(window).on("load", function() {
    // If Facebook SDK failed to load, show old sharer URL
    if (typeof FB === "undefined") {
        console.log('Facebook SDK failed to load ...');
        jQuery('a.facebook-share-url').removeClass('hide');
        jQuery('a.facebook-share-sdk').addClass('hide');
        jQuery('a.facebook-send-sdk').addClass('hide');
    }
});